import React from 'react'
import {Tab, Tabs} from "@mui/material";
import stringUtils from "../../utils/string_utils"
import commonColorUtils from "../../utils/common_colors";

const FirstMileTabs = ({activeTabValue, handleOnChangeTabs}) => {
    const styleOfTab = {
        width: '238px',
        fontFamily: 'Inter, Arial, sans-serif',
        color: commonColorUtils.primaryGrey600,
        fontWeight: 600,
        margin: '6px 20px',
        textTransform: "none",
        fontSize: '14px',
        '&.Mui-selected': {
            color: commonColorUtils.primaryMainBlue,  // Color when tab is selected
        },
    }
    return (
        <>
            <Tabs value={activeTabValue} onChange={handleOnChangeTabs}
                  sx={{width: '100%', borderBottom: `1px solid ${commonColorUtils.primaryGrey300}`}}
                  TabIndicatorProps={{
                      style: {
                          backgroundColor: commonColorUtils.primaryMainBlue,  // Underline color when the tab is selected
                      },
                  }}>
                <Tab label={stringUtils.orders} sx={styleOfTab}/>
                <Tab label={stringUtils.taskAllocation} sx={styleOfTab}/>
                <Tab label={stringUtils.driverRepository} sx={styleOfTab}/>
                <Tab label={stringUtils.locationRepository} sx={styleOfTab}/>
            </Tabs>
        </>
    )
}
export default FirstMileTabs